import { Button } from "@patient-watch/ui/button";
import { cn } from "@/lib/utils";
import { useNavigate } from "@tanstack/react-router";

import { homeRoute } from "../../../utils/nav";
import { Thetis } from "@patient-watch/icons";
import { useProfileCopy } from "@/features/i18n/profileCopy";

const MainIcon = () => {
    const navigate = useNavigate();
    const copy = useProfileCopy();

    const handleHome = () => {
        void navigate(homeRoute.route as never);
    };

    return (
        <Button
            size="sm"
            variant="ghost"
            className="gap-x-0 bg-transparent backdrop-blur-none px-2"
            onClick={handleHome}
        >
            <span className={cn("gap-x-2 bg-transparent px-0 text-slate-800 dark:text-slate-200")}>
                <span className="[&_svg]:w-[35px] [&_svg]:h-[35px]">
                    <Thetis />
                </span>
                <span className="sr-only">{copy.home}</span>
            </span>
        </Button>
    );
};

export default MainIcon;
